import { buildingFootprint, isBoxOrder, TERRITORY_R } from './constants'
import { hexKey, hexSpiral, type Axial } from './hex'
import type { Building } from './types'

/** Two hexes beyond every occupied tile. Ground work orders do not claim land.
 *  Kept independent of completion so placement previews use the same outline. */
export function buildingClaimTiles(b: Pick<Building, 'type' | 'q' | 'r' | 'dir'>): Axial[] {
  if (b.type === 'road' || isBoxOrder(b.type)) return []
  const tiles = new Map<string, Axial>()
  for (const at of buildingFootprint(b.type, b.q, b.r, b.dir)) {
    for (const p of hexSpiral(at.q, at.r, TERRITORY_R)) tiles.set(hexKey(p.q, p.r), p)
  }
  return [...tiles.values()]
}
